export const adminsSelection = [
    { value: "bb4d8218-267d-40cd-90b9-dc5f642974ec", label: "Gilles Bazelaire" },
    { value: "64d0704c-2eac-49ae-829b-86d05a1788b0", label: "Marine Keresztes" },
];
